import { __extends } from "tslib";
import * as React from 'react';
import { PureComponent } from 'react';
import * as ReactDOM from 'react-dom';
import PortalContext from './PortalContext';
import ready from './ready';
var PortalProvider = /** @class */ (function (_super) {
    __extends(PortalProvider, _super);
    function PortalProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            portals: new Map()
        };
        _this.createPortal = function (children) {
            var element = document.createElement('div');
            ready(function () {
                document.body.appendChild(element);
                _this.setState(function (_a) {
                    var currentPortals = _a.portals;
                    var portals = new Map(currentPortals);
                    portals.set(element, children);
                    return { portals: portals };
                });
            });
            return element;
        };
        _this.updatePortal = function (element, children) {
            var currentPortals = _this.state.portals;
            if (currentPortals.get(element) === children)
                return;
            _this.setState(function (_a) {
                var previousPortals = _a.portals;
                var portals = new Map(previousPortals);
                portals.set(element, children);
                return { portals: portals };
            });
        };
        _this.destroyPortal = function (element) {
            document.body.removeChild(element);
            _this.setState(function (_a) {
                var currentPortals = _a.portals;
                var portals = new Map(currentPortals);
                portals.delete(element);
                return { portals: portals };
            });
        };
        return _this;
    }
    PortalProvider.prototype.render = function () {
        var children = this.props.children;
        var portals = this.state.portals;
        return (React.createElement(PortalContext.Provider, { value: {
                createPortal: this.createPortal,
                destroyPortal: this.destroyPortal,
                updatePortal: this.updatePortal
            } },
            children,
            Array.from(portals.entries()).map(function (_a) {
                var el = _a[0], child = _a[1];
                return ReactDOM.createPortal(React.Children.toArray(child), el);
            })));
    };
    PortalProvider.defaultProps = {
        children: []
    };
    return PortalProvider;
}(PureComponent));
export default PortalProvider;
//# sourceMappingURL=PortalProvider.js.map